module.exports = __webpack_public_path__ + "img/foto_10.e5292f1c.png";